import { HttpErrorResponse } from '@angular/common/http';

/**
 * Safe diagnostic string for a caught error, for use in log `full_message` /
 * `error` fields.
 *
 * @ticket EB-3798
 * NEVER log `HttpErrorResponse.message` directly: Angular formats it with the
 * FULL request URL including the query string (e.g. `?search=<name>`), which
 * leaks operator/customer input into Graylog. For an HTTP error we emit only
 * `<status> on <path>` with the query string stripped; a non-HTTP error falls
 * back to `String(err)`. (`String()` on an `HttpErrorResponse` would itself be
 * useless — it yields `"[object Object]"` — which is why the type check comes
 * first.)
 */
export function safeHttpMessage(err: unknown): string {
  if (err instanceof HttpErrorResponse) {
    const path = err.url?.split('?')[0] ?? '<unknown>';
    return `${err.status} on ${path}`;
  }
  return String(err);
}
